import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Select from "../../Pages/Public/Select";
import Login from "../../Pages/Public/Login";
import TwoFactorAuthentication from "../../Pages/Public/TwoFactorAuthentication";
import ForgotPassword from "../../Pages/Public/ForgotPassword";
import ResetPassword from "../../Pages/Public/ResetPassword";
import CheckEmail from "../../Pages/Public/CheckEmail";
import RequestSubmitted from "../../Pages/Public/RequestSubmitted";
import FleetManagerSignUp from "../../Pages/Public/FleetManagerSignUp";
import FuelVendorSignUp from "../../Pages/Public/FuelVendorSignUp";
import EditProfile from "../../Pages/FleetManager/CompanyDetail";

const PublicRoutes = ({ setUser, portal }) => {
  const sharedPortal = portal === "admin" ? "admin" : portal === "vendor" ? "vendor" : "manager";

  return (
    <Routes>
      <Route path="/selection" element={<Select setUser={setUser} />} />

      <Route
        path="/login-admin"
        element={<Login setUser={setUser} portal="admin" />}
      />
      <Route
        path="/login-manager"
        element={<Login setUser={setUser} portal="manager" />}
      />
      <Route
        path="/login-vendor"
        element={<Login setUser={setUser} portal="vendor" />}
      />

      <Route
        path="/sign-up"
        element={<FleetManagerSignUp setUser={setUser} />}
      />
      <Route
        path="/sign-up-vendor"
        element={<FuelVendorSignUp setUser={setUser} />}
      />

      <Route
        path="/company-details"
        element={<EditProfile setUser={setUser} />}
      />

      <Route
        path="/request-submitted"
        element={<RequestSubmitted setUser={setUser} portal="manager" />}
      />
      <Route
        path="/request-submitted-vendor"
        element={<RequestSubmitted setUser={setUser} portal="vendor" />}
      />

      <Route
        path="/forgot-password"
        element={
          <ForgotPassword
            setUser={setUser}
            portal={sharedPortal === "vendor" ? "manager" : sharedPortal}
          />
        }
      />
      <Route
        path="/forgot-password-vendor"
        element={<ForgotPassword setUser={setUser} portal="vendor" />}
      />

      <Route
        path="/reset-password"
        element={
          <ResetPassword
            setUser={setUser}
            portal={sharedPortal === "vendor" ? "manager" : sharedPortal}
          />
        }
      />
      <Route
        path="/reset-password-vendor"
        element={<ResetPassword setUser={setUser} portal="vendor" />}
      />

      <Route
        path="/verify-email"
        element={<CheckEmail setUser={setUser} portal={sharedPortal} />}
      />

      <Route
        path="/two-factor-authentication"
        element={
          <TwoFactorAuthentication setUser={setUser} portal={sharedPortal} />
        }
      />

      <Route path="*" element={<Navigate to="/selection" />} />
    </Routes>
  );
};

export default PublicRoutes;
